import { API_BASE } from "./config";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Container, Box, Alert, IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function Login({ saveToken }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await fetch(`${API_BASE}/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ username, password }),
      });
      if (!res.ok) throw new Error("Credenziali errate");
      const data = await res.json();
      const token = data.access_token;
      const payload = JSON.parse(atob(token.split(".")[1]));
      saveToken(token, payload.role);
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src="logo.png"
            alt="Hedone Club"
            style={{ height: 40, cursor: 'pointer' }}
            onClick={() => navigate('/')}
          />
        </Box>
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required fullWidth
            label="Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
          <TextField
            margin="normal"
            required fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3 }}>
            Accedi
          </Button>
          <Button sx={{ mt: 3 }} fullWidth variant="outlined"  onClick={() => navigate("/register")}>Diventa socio</Button>
          <Button
            sx={{ mt: 1 }}
            fullWidth
            variant="text"
            onClick={() => navigate("/forgot-password")}
          >
            Password dimenticata?
          </Button>      
        </Box>
      </Box>
    </Container>
  );
}

export default Login;
